export function addIcon(fill) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6C0 5.77909 0.179086 5.6 0.4 5.6H11.6C11.8209 5.6 12 5.77909 12 6C12 6.22091 11.8209 6.4 11.6 6.4H0.4C0.179086 6.4 0 6.22091 0 6Z"
        fill="#2D70E2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C6.22091 0 6.4 0.179086 6.4 0.4V11.6C6.4 11.8209 6.22091 12 6 12C5.77909 12 5.6 11.8209 5.6 11.6V0.4C5.6 0.179086 5.77909 0 6 0Z"
        fill="#2D70E2"
      />
    </svg>
  );
}

export function removeIcon(fill) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.142716 0.142716C0.333003 -0.0475719 0.64152 -0.0475719 0.831808 0.142716L11.8573 11.1682C12.0476 11.3585 12.0476 11.667 11.8573 11.8573C11.667 12.0476 11.3585 12.0476 11.1682 11.8573L0.142716 0.831808C-0.0475719 0.64152 -0.0475719 0.333003 0.142716 0.142716Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8573 0.142716C12.0476 0.333003 12.0476 0.64152 11.8573 0.831808L0.831808 11.8573C0.641521 12.0476 0.333004 12.0476 0.142716 11.8573C-0.0475714 11.667 -0.0475713 11.3585 0.142716 11.1682L11.1682 0.142716C11.3585 -0.0475719 11.667 -0.0475719 11.8573 0.142716Z"
        fill={fill}
      />
    </svg>
  );
}

export function chatBubble(fill) {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H19C19.2761 0.5 19.5 0.723858 19.5 1V14C19.5 14.2761 19.2761 14.5 19 14.5H11.1514L5.27735 18.416C5.12392 18.5183 4.92665 18.5278 4.76407 18.4408C4.60149 18.3538 4.5 18.1844 4.5 18V14.5H1C0.723858 14.5 0.5 14.2761 0.5 14V1ZM1.5 1.5V13.5H5C5.27614 13.5 5.5 13.7239 5.5 14V17.0657L10.7226 13.584C10.8048 13.5292 10.9013 13.5 11 13.5H18.5V1.5H1.5Z"
        fill={fill}
      />
    </svg>
  );
}

export function elipseDot() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill="#2D70E2" />
    </svg>
  );
}

export function toolTip() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.91737 11C9.91737 9.91667 10.771 9.73537 11.065 9.44215C11.3599 9.14797 11.5424 8.74113 11.5424 8.29167C11.5424 7.39421 10.8148 6.66667 9.91737 6.66667C9.43208 6.66667 8.99647 6.8794 8.69872 7.21669C8.56104 7.37265 8.45283 7.55524 8.38281 7.75575"
        stroke="#666D79"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91667 13.1667C10.2158 13.1667 10.4583 12.9241 10.4583 12.625C10.4583 12.3258 10.2158 12.0833 9.91667 12.0833C9.61751 12.0833 9.375 12.3258 9.375 12.625C9.375 12.9241 9.61751 13.1667 9.91667 13.1667Z"
        fill="#666D79"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9.91667C4 6.64898 6.64898 4 9.91667 4C13.1844 4 15.8333 6.64898 15.8333 9.91667C15.8333 13.1844 13.1844 15.8333 9.91667 15.8333C6.64898 15.8333 4 13.1844 4 9.91667ZM9.91667 5C7.20127 5 5 7.20127 5 9.91667C5 12.6321 7.20127 14.8333 9.91667 14.8333C12.6321 14.8333 14.8333 12.6321 14.8333 9.91667C14.8333 7.20127 12.6321 5 9.91667 5Z"
        fill="#666D79"
      />
    </svg>
  );
}

export function deleteIcon(fill) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 5.30951C4.5 5.03337 4.72386 4.80951 5 4.80951H14.1667C14.4428 4.80951 14.6667 5.03337 14.6667 5.30951C14.6667 5.58565 14.4428 5.80951 14.1667 5.80951H5C4.72386 5.80951 4.5 5.58565 4.5 5.30951Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.77344 4.65475C7.77344 4.37861 7.9973 4.15475 8.27344 4.15475H10.8925C11.1686 4.15475 11.3925 4.37861 11.3925 4.65475C11.3925 4.9309 11.1686 5.15475 10.8925 5.15475H8.27344C7.9973 5.15475 7.77344 4.9309 7.77344 4.65475Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6543 7.42856C5.93044 7.42856 6.1543 7.65242 6.1543 7.92856V14.6309H13.0114V7.92923L13.5114 7.92856L14.0114 7.92863V15.6309H5.1543V7.92856C5.1543 7.65242 5.37815 7.42856 5.6543 7.42856ZM13.5114 7.92856L14.0114 7.92863C14.0114 7.65249 13.7876 7.42856 13.5114 7.42856C13.2353 7.42856 13.0114 7.65309 13.0114 7.92923L13.5114 7.92856Z"
        fill={fill}
      />
    </svg>
  );
}

export function avatarIcon(fill) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="8" fill="#27CDA7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3903 13.5625C16.8248 14.2695 16.5 15.3869 16.5 17C16.5 19.3784 17.206 20.5161 17.7591 21.1799C17.885 21.3309 18.0046 21.4593 18.1195 21.5827C18.1375 21.602 18.1553 21.6212 18.173 21.6402C18.2948 21.7714 18.4316 21.9204 18.53 22.0734C18.6329 22.2336 18.7319 22.4555 18.697 22.7244C18.6632 22.9852 18.516 23.1911 18.3536 23.3536C17.7974 23.9097 17.1165 24.3133 16.4424 24.6503C16.1043 24.8194 15.7597 24.9756 15.429 25.1254L15.4213 25.1288C15.0901 25.2788 14.7737 25.4222 14.4736 25.5722C13.8637 25.8772 13.3703 26.1869 13.0285 26.5681C12.7018 26.9326 12.5 27.3773 12.5 28C12.5 28.2761 12.2761 28.5 12 28.5C11.7239 28.5 11.5 28.2761 11.5 28C11.5 27.1227 11.7982 26.4424 12.284 25.9006C12.7547 25.3756 13.3863 24.9978 14.0264 24.6778C14.3438 24.5191 14.6752 24.369 15.0001 24.2218L15.0164 24.2145C15.3497 24.0635 15.677 23.915 15.9951 23.7559C16.6335 23.4367 17.2026 23.0903 17.6464 22.6464C17.6622 22.6307 17.6744 22.6174 17.6837 22.6064C17.6407 22.5416 17.5673 22.4575 17.4402 22.3207C17.424 22.3033 17.4072 22.2852 17.3898 22.2665C17.2753 22.1436 17.1358 21.994 16.9909 21.8201C16.294 20.9839 15.5 19.6216 15.5 17C15.5 15.2801 15.8417 13.8975 16.6094 12.9378C17.3942 11.9568 18.5561 11.5 20 11.5C21.4439 11.5 22.6058 11.9568 23.3906 12.9378C24.1583 13.8975 24.5 15.2801 24.5 17C24.5 19.6216 23.706 20.9839 23.0091 21.8201C22.8642 21.994 22.7247 22.1437 22.6102 22.2665C22.5928 22.2852 22.5759 22.3033 22.5598 22.3207C22.4327 22.4575 22.3593 22.5416 22.3163 22.6064C22.3256 22.6174 22.3378 22.6307 22.3536 22.6464C22.7974 23.0903 23.3665 23.4367 24.0049 23.7559C24.323 23.915 24.6503 24.0635 24.9836 24.2145L24.9999 24.2218C25.3248 24.369 25.6563 24.5191 25.9736 24.6778C26.6137 24.9978 27.2453 25.3756 27.716 25.9006C28.2018 26.4424 28.5 27.1227 28.5 28C28.5 28.2761 28.2761 28.5 28 28.5C27.7239 28.5 27.5 28.2761 27.5 28C27.5 27.3773 27.2982 26.9326 26.9715 26.5681C26.6297 26.1869 26.1363 25.8772 25.5264 25.5722C25.2263 25.4222 24.9098 25.2788 24.5787 25.1288L24.571 25.1254C24.2403 24.9756 23.8957 24.8194 23.5576 24.6503C22.8835 24.3133 22.2026 23.9097 21.6464 23.3536C21.484 23.1911 21.3368 22.9852 21.303 22.7244C21.2681 22.4555 21.3671 22.2336 21.47 22.0734C21.5684 21.9204 21.7052 21.7714 21.827 21.6402C21.8447 21.6211 21.8625 21.602 21.8805 21.5827C21.9954 21.4593 22.115 21.3309 22.2409 21.1799C22.794 20.5161 23.5 19.3784 23.5 17C23.5 15.3869 23.1752 14.2695 22.6097 13.5625C22.0612 12.8767 21.2231 12.5 20 12.5C18.7769 12.5 17.9388 12.8767 17.3903 13.5625ZM22.2913 22.6498C22.2913 22.6498 22.2913 22.6497 22.2915 22.6493L22.2913 22.6498Z"
        fill="white"
      />
    </svg>
  );
}

export function AiIcon(fill) {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1389 18.7668C18.9017 18.7668 18.7021 18.6829 18.5398 18.5151C18.3776 18.3473 18.2965 18.1409 18.2965 17.8956V9.59098C18.2965 9.34577 18.3776 9.13929 18.5398 8.97152C18.7021 8.79084 18.9017 8.7005 19.1389 8.7005C19.3885 8.7005 19.5944 8.78439 19.7566 8.95216C19.9189 9.11993 20 9.33287 20 9.59098V17.8956C20 18.1409 19.9126 18.3473 19.7379 18.5151C19.5757 18.6829 19.376 18.7668 19.1389 18.7668Z"
        fill="white"
      />
      <path
        d="M18.5331 6.71753C18.6908 6.88064 18.8801 6.9622 19.1009 6.9622H19.1956C19.4164 6.9622 19.6057 6.88064 19.7634 6.71753C19.9211 6.55442 20 6.35868 20 6.13033V6.06508C20 5.83672 19.9211 5.64099 19.7634 5.47787C19.6057 5.31476 19.4164 5.23321 19.1956 5.23321H19.1009C18.8801 5.23321 18.6908 5.31476 18.5331 5.47787C18.3753 5.64099 18.2965 5.83672 18.2965 6.06508V6.13033C18.2965 6.35868 18.3753 6.55442 18.5331 6.71753Z"
        fill="white"
      />
      <path
        d="M0.861115 5.2374C1.09823 5.2374 1.29791 5.32122 1.46015 5.48888C1.62239 5.65653 1.70351 5.86287 1.70351 6.1079V14.4067C1.70351 14.6517 1.62239 14.8581 1.46015 15.0257C1.29791 15.2063 1.09823 15.2965 0.861115 15.2965C0.611516 15.2965 0.405596 15.2127 0.243357 15.0451C0.0811174 14.8774 0 14.6646 0 14.4067V6.1079C0 5.86287 0.0873585 5.65653 0.262078 5.48888C0.424317 5.32122 0.623996 5.2374 0.861115 5.2374Z"
        fill="white"
      />
      <path
        d="M1.46693 17.2792C1.3092 17.1162 1.11992 17.0347 0.89909 17.0347H0.804451C0.583623 17.0347 0.394341 17.1162 0.236607 17.2792C0.0788722 17.4422 5.03191e-06 17.6378 5.03191e-06 17.866V17.9312C5.03191e-06 18.1594 0.0788722 18.355 0.236607 18.518C0.394341 18.681 0.583623 18.7625 0.804451 18.7625H0.89909C1.11992 18.7625 1.3092 18.681 1.46693 18.518C1.62467 18.355 1.70354 18.1594 1.70354 17.9312V17.866C1.70354 17.6378 1.62467 17.4422 1.46693 17.2792Z"
        fill="white"
      />
      <path
        d="M13.7232 2.62093C13.7232 2.13448 14.1046 1.74013 14.575 1.74013C15.0454 1.74013 15.4267 2.13448 15.4267 2.62093V21.379C15.4267 21.8655 15.0454 22.2598 14.575 22.2598C14.1046 22.2598 13.7232 21.8655 13.7232 21.379V2.62093Z"
        fill="white"
      />
      <path
        d="M4.57663 2.62093C4.57663 2.13448 4.95798 1.74013 5.42839 1.74013C5.8988 1.74013 6.28015 2.13448 6.28015 2.62093V21.379C6.28015 21.8655 5.8988 22.2598 5.42839 22.2598C4.95798 22.2598 4.57663 21.8655 4.57663 21.379V2.62093Z"
        fill="white"
      />
      <path
        d="M9.1499 0.880798C9.1499 0.394347 9.53125 0 10.0017 0C10.4721 0 10.8534 0.394347 10.8534 0.880799V10.2502C10.8534 10.7366 10.4721 11.131 10.0017 11.131C9.53125 11.131 9.1499 10.7366 9.1499 10.2502V0.880798Z"
        fill="white"
      />
      <path
        d="M9.1499 13.7498C9.1499 13.2634 9.53125 12.869 10.0017 12.869C10.4721 12.869 10.8534 13.2634 10.8534 13.7498V23.1192C10.8534 23.6056 10.4721 24 10.0017 24C9.53125 24 9.1499 23.6056 9.1499 23.1192V13.7498Z"
        fill="white"
      />
    </svg>
  );
}
